<template>
  <span class="splicing-circle-icon" :style="{backgroundColor: iconColor}" />
</template>

<script>
export default {
  name: "ConnectionPointColorIcon",

  props: {
    iconColor: String
  }
};
</script>
<style>
.splicing-circle-icon{
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/ConnectionPointColorIcon.vue